module.exports = __webpack_public_path__ + "static/img/Home07@2x.f908c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home07@2x.png
// module id = pWHL
// module chunks = 1